import Http from '../api/http';

export default class userLoginDeviceLog extends Http {
  constructor() {
    super();
  }
  // 电脑登录风险列表
  userComputerLoginRisks_getListByPage() {
    return super.post('loginInfoC/getList', ...arguments);
  }
  // 城市下拉列表
  userComputerLoginRisks_getCity() {
    return super.post('loginInfoC/getCity', ...arguments);
  }
  // 手动排除风险
  userComputerLoginRisks_manualExclusion() {
    return super.post('loginInfoC/manualExclusion', ...arguments);
  }
  // 恢复可疑风险
  userComputerLoginRisks_suspiciousRecovery() {
    return super.post('loginInfoC/suspiciousRecovery', ...arguments);
  }
  // 导出
  userComputerLoginRisks_export() {
    return super.post('loginInfoC/export', ...arguments);
  }
}
